import * as React from "react";
import {
  Box,
  Button,
  Container,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import PostData from "../../data/Posts";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../../common/seo";

const HUB_PATH = "/best-food-northwest-arkansas";

export function BestFood() {
  const bestFood = React.useMemo(() => {
    return PostData.filter(
      (post) => post.category === "food" || post.tags?.includes("food")
    );
  }, []);

  const title = "Best Food in Northwest Arkansas | NWA Blog";
  const description =
    "A curated hub of the best food spots in Northwest Arkansas—photos, quick reviews, and easy links.";

  return (
    <Container component="section" sx={{ marginTop: "5rem" }}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl(HUB_PATH)} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl(HUB_PATH)} />
      </Helmet>

      <Paper elevation={1} sx={{ padding: "1rem", textAlign: "center" }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Best Food in Northwest Arkansas
        </Typography>
        <Typography variant="body2" sx={{ marginTop: ".5rem" }}>
          Quick links to the best food posts.
        </Typography>
      </Paper>

      <Box sx={{ marginTop: "1rem" }}>
        <List>
          {bestFood.map((post, i) => (
            <ListItem key={i} disablePadding sx={{ marginBottom: ".75rem" }}>
              <ListItemButton
                component={RouterLink}
                to={`/${post.link}`}
                sx={{ padding: 0 }}
              >
                <Paper
                  elevation={2}
                  sx={{
                    width: "100%",
                    border: "2px solid",
                    borderColor: "accent.main",
                    borderRadius: 3,
                    overflow: "hidden",
                  }}
                >
                  <Box sx={{ bgcolor: "accent.main", height: ".25rem" }} />
                  <Box sx={{ bgcolor: "secondary.main", height: ".5rem" }} />
                  <Box sx={{ padding: ".75rem" }}>
                    <Typography variant="h6" sx={{ color: "accent.main" }}>
                      {post.title}
                    </Typography>
                    <Typography variant="body2">{post.subTitle}</Typography>
                  </Box>
                </Paper>
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        <Typography variant="body2" sx={{ marginTop: "1rem" }}>
          Want to share a photo credit or request removal? See{" "}
          <Button
            component={RouterLink}
            to="/copyright"
            variant="outlined"
            size="small"
            sx={{
              textTransform: "none",
              color: "accent.main",
              borderColor: "accent.main",
              "&:hover": { borderColor: "accent.main" },
            }}
          >
            copyright
          </Button>
          .
        </Typography>
      </Box>
    </Container>
  );
}
